import { Card, CardContent } from "@material-ui/core";
import { AnnouncementCreate_announcementCreate_errors } from "@saleor/announcements/types/AnnouncementCreate";
import CardTitle from "@saleor/components/CardTitle";
import RichTextEditor from "@saleor/components/RichTextEditor";
import { FormChange } from "@saleor/hooks/useForm";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getAnnouncementErrorMessage from "@saleor/utils/errors/announcement";
import { RawDraftContentState } from "draft-js";
import React from "react";
import { useIntl } from "react-intl";

export interface AnnouncementContentProps {
  disabled: boolean;
  errors: AnnouncementCreate_announcementCreate_errors[];
  onChange: FormChange;
  initialDescription?: RawDraftContentState;
  localError: { content: string };
}

const AnnouncementContent: React.FC<AnnouncementContentProps> = props => {
  const { disabled, onChange, initialDescription, errors, localError } = props;
  const intl = useIntl();

  const formErrors = getFormErrors(["content"], errors || []);

  return (
    <Card>
      <CardTitle title={intl.formatMessage(commonMessages.content)} />
      <CardContent>
        <RichTextEditor
          disabled={disabled}
          error={!!formErrors.content || !!localError.content}
          helperText={
            !!localError.content
              ? localError.content
              : getAnnouncementErrorMessage(formErrors.content, intl)
          }
          initial={initialDescription}
          label={intl.formatMessage(commonMessages.description)}
          name="content"
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
};

export default AnnouncementContent;
